import { connect } from 'react-redux';
import PropertyTypes from './PropertyTypes';

const mapStateToProps = ({
  content: {
    propertyTypes
  },
  system: {
    siteName
  }
}) => ({
  propertyTypes,
  siteName
});

export default connect(mapStateToProps)(PropertyTypes);



// WEBPACK FOOTER //
// ./src/universal/components/PropertyTypes/index.js